import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom";

const Home = () => {
    const navigate = useNavigate()

    // 현재 대시보드 화면이 준비되지 않았으므로 바로 리뷰 목록 화면으로 이동
    useEffect(() => {
        navigate('/review/list')
    })
    
    return (
        <>
        </>
    );
};

export default Home